module.exports = __webpack_public_path__ + "images/5753ddbf6bd0ff42ef4c962b01a2ecbc-PurpleMessagesbutton.png";